export const WALLET_USER_NAME_KEY = 'walletUsername';
export const LOCAL_STORAGE_ADDRESSES_KEY = 'Addresses';
export const APP_VERSION_KEY = 'AppVersion';
//# sourceMappingURL=constants.js.map